// src/components/ServicesPage.js
import React from "react";
import { Card } from "primereact/card";
import "../styles/ServicesPage.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { FaQuestionCircle, FaLightbulb } from "react-icons/fa";
import FAQSection from "../Components/FaqSection";

const services = [
  {
    title: "Beginner Driving Course",
    link: "/courses/beginner",
    description:
      "Perfect for new drivers. A structured program covering road safety, controls, and confidence-building essentials.",
    icon: "pi pi-car",
    color: "#219EBC",
  },
  {
    title: "Intermediate Driving Course",
    link: "/courses/intermediate",
    description:
      "Refine your driving techniques, eliminate weaknesses, and prepare strategically for your driving test.",
    icon: "pi pi-star",
    color: "#023047",
  },
  {
    title: "Refresher Course",
    link: "/courses/refresher",
    description:
      "Update your skills and driving knowledge with a focused refresher tailored to modern road challenges.",
    icon: "pi pi-refresh",
    color: "#8ECAE6",
  },
  {
    title: "Mock Driving Tests",
    link: "/booking",
    description:
      "Experience a simulated test environment with professional feedback to boost readiness and confidence.",
    icon: "pi pi-check-circle",
    color: "#FFB703",
  },
  {
    title: "Course Recommender",
    link: "/course-recommender",
    description:
      "Not sure which course is right for you? Our smart recommender guides you to the best fit for your goals.",
    customIcon: <FaLightbulb size={50} />,
    color: "#FB8500",
  },
  // {
  //   title: "FAQs",
  //   link: "/faqs",
  //   description:
  //     "Find quick answers to common questions about booking, policies, and our driving school services.",
  //   customIcon: <FaQuestionCircle size={50} />,
  //   color: "#023047",
  // },
];

const ServicesPage = () => {
  return (
    <div className="services-page container">
      <Helmet>
        <title>Driving School Services | Pass Swiftly</title>
        <meta
          name="description"
          content="Explore Pass Swiftly’s driving services: beginner, intermediate, refresher, mock tests, FAQs, and course recommender tool."
        />
      </Helmet>

      <h1 className="text-4xl font-bold mb-5 text-primary">Our Services</h1>

      <div className="flex flex-wrap justify-content-center gap-4">
        {services.map((service, index) => (
          <Link to={service.link} key={index} className="text-decoration-none">
            <Card
              className="service-card flex flex-column align-items-center p-4 border-round-lg shadow-3"
              style={{ width: "300px", height: "360px" }}
            >
              <div className="flex align-items-center justify-content-center w-full">
                <div
                  className="icon-wrapper  flex align-items-center justify-content-center mb-3 border-circle"
                  style={{
                    backgroundColor: service.color,
                    width: "80px",
                    height: "80px",
                  }}
                >
                  {service.customIcon ? (
                    <span className="text-white text-center">
                      {service.customIcon}
                    </span>
                  ) : (
                    <i
                      className={`${service.icon} text-white text-center`}
                      style={{ fontSize: "2.5rem" }}
                    />
                  )}
                </div>
              </div>
              <div className="text-center">
                <h2 className="text-xl font-semibold mb-2 text-900">
                  {service.title}
                </h2>
                <p className="text-sm text-700">{service.description}</p>
              </div>
            </Card>
          </Link>
        ))}
      </div>
      <FAQSection />
    </div>
  );
};

export default ServicesPage;
